import axios from 'axios'
import Vue from 'vue'
import i18n from '@/lang/i18n'
import store from '../store'

// ----------------------
// Refresh Auth Logic
// ----------------------

export const refreshAuthLogic = async failedRequest => {
  console.log('[Auth] Token refresh attempt started')

  const { typeOfUser, refreshToken, token: idToken } = store.state.auth
  if (!refreshToken) {
    console.error('[Auth] Refresh failed: No refresh token available')
    return Promise.reject(new Error('No refresh token available'))
  }

  const refreshTokenPath =
    typeOfUser === 'pharmacy' ? `pharmacy/auth/refresh-token` : `auth/refresh-token`

  console.log(`[Auth] Using refresh path: ${refreshTokenPath} for user type: ${typeOfUser}`)

  try {
    console.log('[Auth] Sending refresh token request...')
    const { data } = await axios.get(refreshTokenPath, {
      baseURL: process.env.MIX_DR_API_HOST_NAME,
      params: { refreshtoken: refreshToken },
      headers: {
        'X-From': window.location.href,
        Authorization: `Bearer ${idToken}`
      }
    })

    console.log('[Auth] Token refresh successful')
    const { token: newIdToken, AccessToken } = data

    if (!newIdToken || !AccessToken) {
      console.error('[Auth] Refresh failed: Invalid response structure from API')
      throw new Error('Invalid response from refresh token endpoint')
    }

    console.log('[Auth] Updating tokens in store')
    await store.dispatch('auth/setToken', newIdToken)
    await store.dispatch('auth/setAccessToken', AccessToken)
    failedRequest.config.headers.Authorization = `Bearer ${newIdToken}`

    console.log('[Auth] Token refresh process completed successfully')
    return Promise.resolve()
  } catch (err) {
    console.error('[Auth] Token refresh failed:', err.message || err)

    if (err.response) {
      console.error('[Auth] Server response:', {
        status: err.response.status,
        data: err.response.data
      })
    }

    const msg = i18n.t('the_token_has_expired')
    console.log('[Auth] Showing expiration alert to user')
    Vue.dialog.alert(msg, { okText: 'OK', backdropClose: true })

    console.log('[Auth] Logging out user')
    store.dispatch('otp/initLogout')
    store.dispatch('auth/logout')
    Vue.router.push({ name: 'Login' })
    return Promise.reject(err)
  }
}
